import { render, staticRenderFns } from "./ExtraRequests.vue?vue&type=template&id=42e0c7da&"
import script from "./ExtraRequests.vue?vue&type=script&lang=js&"
export * from "./ExtraRequests.vue?vue&type=script&lang=js&"
import style0 from "./ExtraRequests.vue?vue&type=style&index=0&id=42e0c7da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports